import {DropZone} from "../DropZone/DropZone"

export const Main = () => {
  return (
    <main className="lg:w-5/6 p-3  mx-auto sm:w-full">
      <h1 className='text-2xl mb-3'>Convert HEIC to JPEG</h1>
      <DropZone/>
    </main>
  )
}